<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Kunden</h1>

    <div class="mt-3">
      <app-customer-search-box (searchCriteria)="search($event)"></app-customer-search-box>
    </div>

    <kendo-grid
      [data]="list.gridData"
      [pageable]="true"
      [skip]="list.state.skip"
      [pageSize]="list.state.pageSize"
      [sortable]="true"
      [sort]="list.state.sort"
      (pageChange)="list.onPageChange($event)"
      (sortChange)="list.onSortChange($event)"
      [reorderable]="true"
      [resizable]="true">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="list.loading" loadingText="Kunden werden geladen…" i18n-loadingText></app-grid-no-records>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridPDFCommand icon="file-pdf" data-testid="customer-list-pdf-button" i18n>PDF-Export</button>
      </ng-template>
      <kendo-grid-column field="fullName" [sortable]="false" i18n-title title="Name"
      format="{0:g}" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="firstName" [sortable]="false" i18n-title title="Vorname"
      format="{0:g}" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="lastName" i18n-title title="Nachname"
      format="{0:g}" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="street" [sortable]="false" i18n-title title="Straße"
        [width]="120">
      </kendo-grid-column>
      <kendo-grid-column field="zip" [sortable]="false" i18n-title title="PLZ"
      [width]="60"></kendo-grid-column>
      <kendo-grid-column field="city" [sortable]="false" i18n-title title="Ort"
      [width]="120">
        <!-- Cell template purely so the value carries a `data-testid`: the E2E specs for
             #18 assert that an edited field shows up in the parent list, and Kendo's own
             cells are only addressable by column position. -->
        <ng-template kendoGridCellTemplate let-dataItem>
          <span data-testid="customer-list-city">{{ dataItem.city }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="email" [sortable]="false" i18n-title title="E-Mail" [width]="100"
     ></kendo-grid-column>
      <kendo-grid-column field="phone" [sortable]="false" i18n-title title="Telefon" [width]="100"
     ></kendo-grid-column>

      @if (profile?.isActive) {
        <kendo-grid-command-column i18n-title
          title="Bearbeiten" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex justify-content-center gap-2">
              <button type="button" class="btn btn-sm btn-outline-secondary" title="Bearbeiten" aria-label="Bearbeiten" i18n-title i18n-aria-label (click)="onEdit(dataItem.id)" data-testid="customer-edit-command">
                <i>
                  <fa-icon [icon]="faEdit"></fa-icon>
                </i>
              </button>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      }

      <kendo-grid-pdf appGridPdf fileName="Kunden.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.7">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <app-pdf-page title="Kundenliste" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
        </ng-template>
      </kendo-grid-pdf>
    </kendo-grid>


  </div>
</div>